import { objectHelper } from "@/helpers";
export default class ConnectedUser {
  id = 0;
  login = "";

  constructor(data) {
    if (data) {
      objectHelper.assignOnlyExisting(this, data);
      this.id = objectHelper.isDefined(data.id) ? data.id : data.userId;
    }
  }
}
